// extracted by mini-css-extract-plugin
module.exports = {"CarouselContainer":"TestimonialsCarousel_CarouselContainer__ZsAFp"};